import { buttonModes, icons, states } from '@/utils'

import button from '@/components/button'

export default function(h) {
  let loading = this.state === states.loading
  if (typeof this.state === 'boolean') {
    loading = this.state
  }

  return h(
    button,
    {
      props: {
        icon: icons.refresh,
        label: this.label,
        mode: buttonModes.flat,
        loading,
        disabled: this.computedDisabled,
        tooltip: this.tooltip
      },
      on: {
        mousedown: this.clickHandler,
        mouseup: this.clickHandler,
        touchstart: this.clickHandler,
        touchend: this.clickHandler
      }
    }
  )
}
